import { annotationScenes, decodeProject, subtitleCues, type EditCommand } from "@linempo/project-domain";
import type { EditorCommands } from "@linempo/react-state";

async function sampleResponse(name: string): Promise<Response> {
  const response = await fetch(`/samples/creative-process/${encodeURIComponent(name)}`);
  if (!response.ok) throw new Error(`无法读取示例素材 ${name}（${response.status}）`);
  return response;
}
export async function openSample(commands: EditorCommands): Promise<void> {
  // Fetch the manifest before replacing the workspace, so a missing sample does not discard it.
  const sample = decodeProject(await (await sampleResponse("project.json")).json());
  const source = await (await sampleResponse("creative-process.srt")).text();
  await commands.newProject(sample.name);
  const track = await commands.importSubtitle(source, "creative-process.srt", "replace");
  const assets = new Map<string, string>();
  for (const asset of sample.assets) {
    const blob = await (await sampleResponse(asset.name)).blob();
    const imported = await commands.importAsset(new File([blob], asset.name, { type: asset.mimeType }));
    assets.set(asset.id, imported.id);
  }
  const cueMap = new Map(subtitleCues(sample).map((cue, index) => [cue.id, track.cues[index]?.id]));
  const trackId = crypto.randomUUID();
  const edits: EditCommand[] = annotationScenes(sample).map(({ animationId: _sourceAnimationId, ...scene }) => ({ _tag: "InsertScene", trackId, scene: {
    ...scene, id: crypto.randomUUID(), assetId: assets.get(scene.assetId)!, cueIds: scene.cueIds.flatMap((id) => cueMap.get(id) ? [cueMap.get(id)!] : []),
    // The new project is clips mode: the domain/planner supplies end-of-clip clearing.
    erase: { _tag: "none" },
  } }));
  if (edits.length) await commands.commit({ commands: edits, label: "添加示例镜头" });
  await commands.saveProject();
  const first = edits[0]; if (first?._tag === "InsertScene") await commands.selectClip(first.scene.id);
}
